/* BeeMax cookie consent (snippets/bmx-cookies.liquid). Saves the visitor's choice with Shopify's Customer Privacy API. */
(function () {
  'use strict';
  var root = document.getElementById('BmxCookies');
  if (!root || root.__bmxCk) return;
  root.__bmxCk = true;
  // Sit directly in <body> so the card stays above other floating buttons (like the chat bubble).
  if (root.parentNode !== document.body) document.body.appendChild(root);
  var prefs = root.querySelector('.bmx-ck__prefs');
  var KEYS = ['preferences', 'analytics', 'marketing'];
  function btn(k) { return root.querySelector('[data-ck="' + k + '"]'); }
  function box(k) { return prefs.querySelector('[name="' + k + '"]'); }

  // Shopify's privacy API is usually on the page already; load it if not.
  function api(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy && S.customerPrivacy.setTrackingConsent) { cb(S.customerPrivacy); return; }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
      });
    }
  }
  function current(cp) {
    try { return (cp.currentVisitorConsent && cp.currentVisitorConsent()) || {}; } catch (e) { return {}; }
  }

  function showPrefs(on) {
    prefs.hidden = !on;
    btn('prefs').hidden = on;
    btn('prefs').setAttribute('aria-expanded', on ? 'true' : 'false');
    btn('save').hidden = !on;
    root.classList.toggle('is-prefs', on);
  }
  // While the card is open, the scroll-to-top button moves up above it, and back down when the card closes.
  var html = document.documentElement;
  function lift(on) {
    if (!on) { html.classList.remove('bmx-ck-open'); return; }
    var gap = parseFloat(getComputedStyle(root).bottom) || 0;
    html.style.setProperty('--bmx-ck-h', Math.round(root.offsetHeight + gap) + 'px');
    html.classList.add('bmx-ck-open');
  }
  if ('ResizeObserver' in window) new ResizeObserver(function () { if (!root.hidden) lift(true); }).observe(root);
  window.addEventListener('resize', function () { if (!root.hidden) lift(true); });

  function open(withPrefs) {
    api(function (cp) {
      var c = current(cp);
      KEYS.forEach(function (k) { var i = box(k); if (i) i.checked = c[k] === 'yes'; });
    });
    showPrefs(!!withPrefs);
    root.hidden = false;
    lift(true);
    requestAnimationFrame(function () { root.classList.add('is-in'); });
    if (withPrefs) { var f = box('preferences'); if (f) f.focus(); }
  }
  function close() {
    lift(false);
    root.classList.remove('is-in');
    setTimeout(function () { root.hidden = true; }, 260);
  }
  function save(v) {
    api(function (cp) {
      try {
        cp.setTrackingConsent({ analytics: v.analytics, marketing: v.marketing, preferences: v.preferences, sale_of_data: v.marketing }, function () {});
      } catch (e) {}
    });
    close();
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ck]');
    if (!b) return;
    var k = b.getAttribute('data-ck');
    if (k === 'all') save({ analytics: true, marketing: true, preferences: true });
    else if (k === 'none') save({ analytics: false, marketing: false, preferences: false });
    else if (k === 'prefs') { showPrefs(true); var f = box('preferences'); if (f) f.focus(); }
    else if (k === 'save') save({ analytics: box('analytics').checked, marketing: box('marketing').checked, preferences: box('preferences').checked });
  });
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // "Cookie settings" in the footer, or any link to #cookie-settings, opens the card with the choices.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cookie-settings], a[href$="#cookie-settings"]');
    if (!t) return;
    e.preventDefault();
    open(true);
  });

  // First visit: show the card until the visitor has made a choice.
  if (location.hash === '#cookie-settings') { open(true); return; }
  api(function (cp) {
    var c = current(cp);
    var chosen = KEYS.some(function (k) { return c[k] === 'yes' || c[k] === 'no'; });
    if (!chosen) open(false);
  });
})();
